<template>
  <button
    class="group no-tap-highlight absolute right-4 top-3 z-50 mx-auto inline-flex h-12 w-12 items-center justify-center rounded-full lg:hidden"
    :class="[
      isMenuVisible && $style.isVisible,
      store.theme === 'gray' ? 'bg-white' : 'bg-light-gray'
    ]"
    :title="isMenuVisible ? $t('menu.hide') : $t('menu.show')"
    @click="menuToggle"
  >
    <div class="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2">
      <span v-for="idx in 3" :key="idx" :class="$style.line"></span>
    </div>
  </button>
</template>

<script setup lang="ts">
import { useAppStore } from '~/stores/AppStore'

const store = useAppStore()
const { menuToggle } = useMenu()
const isMenuVisible = useState('menu')
</script>

<style lang="postcss" module>
.line {
  --line-thickness: 2px;
  --line-width: 16px;
  --line-margin: 4px;
  --line-radius: 0px;
  --line-color: theme(colors.blue.DEFAULT);

  @apply my-[var(--line-margin)] block h-[var(--line-thickness)] w-[var(--line-width)] origin-center transform-gpu rounded-[var(--line-radius)] bg-[var(--line-color)] transition-transform duration-300 ease-quart-in-out;
}

.isVisible {
  .line {
    &:nth-child(1) {
      @apply translate-y-1.5 rotate-[135deg];
    }

    &:nth-child(2) {
      @apply scale-0;
    }

    &:nth-child(3) {
      @apply -translate-y-1.5 -rotate-[135deg];
    }
  }
}
</style>
